// eslint-no-undef
import React from 'react';
import Message from './Message';
import Neighbors from './Neighbors';
import MessageCreator from './MessageCreator';
import spinner from '../images/spinner.gif';
import sairImg from '../images/sair.png';
import {getUserInfo, updateUserInfo} from '../Helpers';
import '../App.css';

const pageSize = 40;
const baseUrl = window.location.protocol + '//' + window.location.host;

// TODO - Convert this to a function based component...
export default class MessageViewer extends React.Component {

  constructor(props) {
    super(props);
    let stateHash = {
      content: '',
      isFetching: false,
      messages: [],
      totalMessages: 0,
      nextPage: 0,
      convo: this.props.conversation,
      convoUsers: this.props.convoUsers || this.props.conversation.users || []
    }
    this.state = stateHash;
  }

  handleScroll(e) {
    if (!e.target) return;
    if (e.target.scrollTop === 0 || (e.target.scrollingElement && e.target.scrollingElement.scrollTop === 0)) {
      this.fetchMessages();
    }
  }

  addToConversation(username) {
    this.props.app.addToConversation(this.props.conversation, username);
  }

  async removeUser(e, user) {
    let users = this.state.convoUsers?.filter(u => u.username !== user.username).map(x => x.username), that = this;
    let updateParams = {
      // uri: `${baseUrl}/api/v1/conversations/${this.props.conversationId}`,
      uri: `/api/v1/conversations/${this.props.conversationId}`,
      method: 'PUT'
    };
    let formData = new FormData();
    for (let i = 0; i < users.length; i++) {
      formData.append('conversation[neighbors][]', users[i]);
    }
    updateParams.body = formData;
    const d = await fetch(updateParams.uri, updateParams);
    d.json().then(data => {
      let convo = data['conversation'];
      that.setState({convoUsers: convo['users']});
      // that.props.convo.setState({convoUsers: convo['users'], title: users.filter(name => name !== that.props.user.username).join(', ')});
    });
  }

  componentDidMount() {
    let users = this.state.convoUsers || this.props.convoUsers;
    let that = this;
    window.removeEventListener('scroll', (e) => this.handleScroll(e));
    this._viewerWindow.addEventListener('scroll', (e) => that.handleScroll(e));
    this.scrollToBottom();
    if (this.props.conversationId) {
      that.fetchMessages(that.props.conversationId);
    }
    this.formatUsernames(users);
    // this.setState({title: '', messages: [], totalMessages: 0, nextPage: 0, convoUsers: newProps.conversation['users']}, function() {
  }

  componentWillUnmount() {
    let that = this;
    this._viewerWindow.removeEventListener('scroll', (e) => that.handleScroll(e));
    window.removeEventListener('scroll', (e) => that.handleScroll(e));
  }

  async fetchMessages(convoId) {
    if (this.state.isFetching) {
      return;
    }
    let that = this, cid = convoId || this.props.conversationId;
    if (!cid) {
      this.setState({
        messages: [],
      });
      return;
    }
    if (this.state.totalMessages && this.state.messages.length >= this.state.totalMessages) {
      // We have already fetched all of the chat messages.
      this.setState({isFetching: false});
      return;
    }
    this.setState({isFetching: true});
    let messages = this.state.messages || [];
    let nextPage = this.state.nextPage || 1;
    const d = await fetch(`/api/v1/conversations/${cid}/messages?page=${nextPage}&per_page=${pageSize}`);
    d.json().then(data => {
      if (data) {
        let parsedBody = data;
        if (parsedBody && parsedBody['messages']) {
          messages = messages.concat(parsedBody['messages']);
          let totalMessages = parsedBody['meta']['total_messages'];
          // note that unread_message_count is for *all* conversations, not just this one.
          that.props.updateMessageStatuses(cid, parsedBody['meta']['unread_message_count']);
          that.setState({
            isFetching: false,
            messages: messages,
            nextPage: (nextPage + 1),
            lastPage: nextPage,
            totalMessages: totalMessages,
          }, that.doScroll);
        }
      }
    });
  }

  doScroll() {
    // or check page num
    if (this.state.messages.length <= pageSize) {
      this.scrollToBottom();
    }  else {
      this.scrollToTop();
    }
  }

  /* componentWillReceiveProps(newProps) {
console.log(" Will receive props CONV : " + JSON.stringify(newProps.conversation));
    if (this.props.conversationId !== newProps.conversationId) {
      let that = this;
      this.setState({title: '', messages: [], totalMessages: 0, nextPage: 0, convoUsers: newProps.conversation['users']}, function() {
        that.fetchMessages(newProps.conversationId);
      });
    }
  } */

  showMembers(e) {
    e.preventDefault();
    // TODO - Awful antipattern here...
    this.props.app.setState({neighborDiv: <Neighbors app={this.props.app} area={this.props.area} />});
  }

  scrollToTop() {
    if (this._viewerWindow) {
      this._viewerWindow.scrollTop = 0;
    }
  }

  scrollToBottom() {
    if (this._viewerWindow) {
      this._viewerWindow.scrollTop = 8000;
    }
  }

  formatMessages() {
    let messages = [];
    if (this.state && this.state.messages) {
      for (let i = (this.state.messages.length - 1); i > -1; i--) {
        let m = <Message key={this.state.messages[i]._id['$oid']} app={this.props.app} userConvoUser={this.props.conversation['conversation_user']}
                         current_user={this.props.user} data={this.state.messages[i]} />;
        messages.push(m);
      }
    }
    return messages;
  }

  showAddUserModal(e) {
    e.preventDefault();
    this.setState({showAddUserModal: true});
  }

  showProfile(e, user) {
    if (e) e.preventDefault();
    this.props.app.showProfile(user);
  }

  onStompConnect(event) {
    console.log('Got stomp connect....');
  }

  hideAddUserModal(e) {
    if (e) e.preventDefault();
    this.setState({showAddUserModal: false});
  }

  async leaveConversation(e) {
    // TODO
    if (e) e.preventDefault();
    let updateParams = {
      uri: `${baseUrl}/api/v1/conversations/${this.props.conversationId}`,
      method: 'DELETE',
    }, that = this;
    const d = await fetch(updateParams.uri, updateParams);
    d.json().then(data => {
      let convo = data['conversation'];
      that.setState({convoUsers: convo['users']});
    });
  }

  showUserMenu(e, user) {
    if (e) e.preventDefault();
    // if (this.props.conversation['conversation_user'] && this.props.conversation['conversation_user']['conversation_role']
        // && this.props.conversation['conversation_user']['conversation_role']['name'].indexOf('Admin') !== -1) {
      this.setState({userMenu: user, userMenuX: e.clientX, userMenuY: e.clientY});
    // }
  }

  formatUsernames(users) {
    let cusers = [];
    let usersArray = [];
    if (users) {
      for (let i = 0; i < users.length; i++) {
        if (typeof users[i] === 'string') {
          users[i] = getUserInfo(this, users[i]);
        } else if (users[i] && users[i]['username'] !== this.props.user.username) {
          cusers.push(users[i]);
        }
      }
      for (let c = 0; c < cusers.length; c++) {
        let className = 'messageViewerUsername';
        if (cusers[c] && cusers[c].conversation_user) {
          if (this.props.user.conv_block_users && this.props.user.conv_block_users.includes(cusers[c].username)) {
            className = 'messageViewerBlockedUser';
          } else if (cusers[c] && cusers[c].conversation_user && cusers[c].conversation_user.conversation_role
              && cusers[c].conversation_user.conversation_role.name === 'Admin') {
            className = 'messageViewerUsernameAdmin';
          } else if (cusers[c].conversation_user.conversation_role && cusers[c].conversation_user.conversation_role.name === 'SuperAdmin') {
            className = 'messageViewerUsernameSuperAdmin';
          }
        }
        if (cusers[c] && cusers[c]._id) {
          usersArray.push( <div key={cusers[c]._id['$oid']} className={className} onClick={(e) => this.showUserMenu(e, cusers[c])}>{cusers[c].username}</div> );
        } else {
          // New conversation and cusers[c] is just the username.
          //   This can't happen because we need an ID for the conversation..
          usersArray.push( <div key={cusers[c]} className={className}>{cusers[c]}</div> );
        }
      }
      return usersArray;
    }
  }

  async makeAdmin(e, convoUser) {
    if (e) e.preventDefault();
    let that = this;
    let url = window.location.protocol + '//' + window.location.host;
    const d = await fetch(`/api/v1/conversations/${this.props.conversationId}/admin?conversation_user_id=${convoUser._id['$oid']}`, {method: 'PUT'});
    d.json().then(data => {
      // TODO - redraw messages so that the 'make admin' becomes a 'unadmin' or similar
      let cu = data['conversation_users'];
      let convoUsers = that.state.convoUsers || that.props.convoUsers;
      let found = false;
      for (let i = 0; i < convoUsers.length; i++) {
        let user = convoUsers[i];
        if (user._id['$oid'] === cu.user_id['$oid']) {
          convoUsers[i].conversation_user = cu;
          found = true;
        }
      }
      if (found) {
        that.setState({convoUsers: convoUsers});
      }
    });
  }

  unmakeAdmin(e, convoUser) {
    if (e) e.preventDefault();
    let that = this;
    let url = window.location.protocol + '//' + window.location.host;
    fetch(`/api/v1/conversations/${this.props.conversationId}/admin?conversation_user_id=${convoUser._id['$oid']}`, {
             method: 'DELETE',
    }, function(err, data) {
      if (err) {
        console.log('[Message] Error when attempting to mark a converastion user as admin: ' + err);
      } else {
        // TODO - redraw messages so that the 'make admin' becomes a 'unadmin' or similar
        let cu = JSON.parse(data.body)['conversation_users'];
        let convoUsers = that.state.convoUsers || that.props.convoUsers;
        let found = false;
        for (let i = 0; i < convoUsers.length; i++) {
          let user = convoUsers[i];
          if (user._id['$oid'] === cu.user_id['$oid']) {
            convoUsers[i].conversation_user = cu;
            found = true;
          }
        }
        if (found) {
          that.setState({convoUsers: convoUsers});
        }
      }
    });
  }

  hideUserMenu(e) {
    if (e) e.preventDefault();
    this.setState({userMenu: false});
  }

  blockUser(user) {
    console.log('BLOCKING THIS USER: ' );
    console.log(user);
    let me = this.props.user;
    me.conv_block_users.push(user.username);
    updateUserInfo(undefined, me);
    this.setState({update: new Date()});
  }

  unblockUser(user) {
    console.log('UNBLOCKING THIS USER: ' );
    console.log(user);
    let me = this.props.user;
    me.conv_block_users = me.conv_block_users.filter(buser => buser.username !== user.username);
    updateUserInfo(undefined, me);
    this.setState({update: new Date()});
  }

  render() {
    let convoHeader = 'Começar uma conversa';
    let users = this.props.conversation['users'];
    let userMenu = '';
    if (this.state.userMenu) {
      let menuUser = this.state.userMenu;
      let makeAdmin = '';
      let unmakeAdmin = '';
      let kickButton = <div className='genericLabelSmall' style={{cursor: 'pointer'}} onClick={(e) => this.removeUser(e, menuUser)}>Kick</div>;
      if (menuUser.conversation_user && !menuUser.conversation_user.conversation_role) {
        makeAdmin = <div className='genericLabelSmall' style={{cursor: 'pointer'}} onClick={(e) => this.makeAdmin(e, menuUser.conversation_user)}>Make Admin</div>;
      } else if (menuUser.conversation_user && menuUser.conversation_user.conversation_role && menuUser.conversation_user.conversation_role.name === 'Admin') {
        unmakeAdmin = <div className='genericLabelSmall' style={{cursor: 'pointer'}} onClick={(e) => this.unmakeAdmin(e, menuUser.conversation_user)}>Remove Admin</div>;
      }
      let userRole = menuUser['conversation_user']?.conversation_role?.name || '';
      if (userRole) {
        userRole = '[' + userRole + ']';
      }
      let blockUser = undefined;
      if (this.props.user.conv_block_users.includes(menuUser.username)) {
        blockUser = <div className='genericLabelSmall' style={{cursor: 'pointer'}} onClick={() => this.unblockUser(menuUser)}>Desbloquear usuario</div>;
      } else {
        blockUser = <div className='genericLabelSmall' style={{cursor: 'pointer'}} onClick={() => this.blockUser(menuUser)}>Bloquear usuario</div>;
      }
      userMenu = <div className='messageUserMenu' style={{left: this.state.userMenuX - 30, top: this.state.userMenuY + 16}}>{menuUser.username} {userRole}
        <div style={{float: 'right'}}><span className='fakeLink' onClick={(e) => this.hideUserMenu(e)}>x</span></div>
        <hr style={{width: '98%'}} />
        {blockUser}
        {makeAdmin}
        {unmakeAdmin}
        <br />
        {kickButton}
        <br />
        <div className='genericLabelSmall' style={{cursor: 'pointer'}} onClick={(e) => this.showProfile(e, menuUser)}>View Profile</div>
      </div>;
    }
    if (!users) {
      if (this.props.conversation['users']) {
        users = this.state.convoUsers.map(cUser => cUser.username);
        users = users.filter(x => x !== this.props.user.username);
      } else if (this.props.neighbor) {
        users = [this.props.neighbor];
      } else {
        users = [];
      }
    }
    if (users) {
      if (users.length === 0 && (!this.state.messages || !this.state.messages.length === 0)) {
        convoHeader = <div className='convoTitle'><font className='genericLabel'><span className='fakeLink' onClick={(e) => this.showMembers(e)}>Iniciar uma conversa</span></font></div>;
      } else {
        let addUserButton = <span onClick={(e) => this.showAddUserModal(e)} className='commentActionFontBlue'><font className='commentActionFontBlue'>[+]</font></span>;
        convoHeader = <div className='convoTitle'>
                     <font className='genericLabel'>{users.length === 1 ? 'Conversa com ' : ''}{this.formatUsernames(users)}</font>
                     <div className='convoSair'><img onClick={(e) => this.leaveConversation(e)}
                          src={sairImg} style={{width: '22px', marginBottom: '-4px'}} alt='' /></div>
                     &nbsp;{addUserButton}
                   </div>;
      }
    }
    let atBeginningMessage = '';
    if (this.state.messages && this.state.totalMessages) {
      if (this.state.messages.length === this.state.totalMessages && this.state.messages.length > pageSize) {
        atBeginningMessage = 'Início da conversa';
      }
    }
    let title = '';
    if (this.props.conversation && this.props.conversation['title']) {
      title = this.props.conversation['title'];
    }
    if (this.props.conversation && this.props.conversation['users']) {
      let myConversationUser = this.props.conversation['users'].filter(user => user.username === this.props.user.username)[0];
      if (myConversationUser?.conversation_user?.conversation_role?.name) {
        title = title + ' [' + myConversationUser.conversation_user.conversation_role.name + ']';
      }
    }

    return (
      <div id='viewerContainer' className='messageViewer' style={{borderLeft: '1px solid #cccccc'}} ref={(ref) => this._viewerContainer = ref}>
        { this.state.showAddUserModal
            ? <div className='greyOverlay'><div className='popupNeighbors' style={{padding: 0, left: `${( ( window.innerWidth / 2 ) - 290 )}px` }}>
                <Neighbors app={this.props.app} area={this.props.user.area} closeMe={this.hideAddUserModal.bind(this)} isModal={true} />
              </div></div>
            : ''}
        {title ? <div className='messageViewerTitle'>{title}</div> : ''}

        {convoHeader}
        <div id='viewerWindow' className='messageViewerInner' style={{padding: '12px', height: `${(window.innerHeight - 210)}px` }} ref={(ref) => this._viewerWindow = ref}>
          <p />
          {this.state.isFetching ? <img style={{marginTop: '110px', width: '80px', marginLeft: '220px'}} className='spinner' src={spinner} alt='' /> : <div>{atBeginningMessage}<br /></div>}
          {this.formatMessages()}
        </div>
        {userMenu}
        <MessageCreator neighbors={users} conversationId={this.props.conversationId} app={this.props.app} user={this.props.user} viewer={this} style={{marginTop: '30px'}} />
      </div>
    );
  }
}
